import * as React from "react"

import {twMerge} from "libs/twmerge"
import AppleIcon from "images/social-apple-v3.svg"
import FacebookIcon from "images/social-facebook-v3.svg"
import GoogleIcon from "images/social-google-v3.svg"
import LineIcon from "images/social-line-v3.svg"

/**
 * @typedef {object} SocialLoginButtonProps
 * @property {keyof socialMap} variant
 * @property {React.ReactNode} [children]
 */

/**
 * @type {React.FC<SocialLoginButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>>}
 */
const SocialLoginButton = ({
  variant,
  children,
  className = "",
  ...restProps
}) => {
  return (
    <button
      {...restProps}
      className={twMerge(
        `
        flex min-h-[40px] items-center justify-center gap-3 rounded-[24px]
        border border-neutral-platinum bg-neutral-white px-4 py-3
        active:border-gray-silver disabled:border-gray-silver disabled:opacity-60
        `,
        className,
      )}
    >
      {socialMap[variant]}
      {children ? (
        <span className="translate-y-px font-action text-[14px] font-semibold leading-4 text-neutral-black">
          {children}
        </span>
      ) : null}
    </button>
  )
}

const socialMap = {
  apple: (
    <span className="flex h-[16px] w-[16px] items-center justify-center">
      <img src={AppleIcon} alt="" className="h-[16px] w-[16px]" />
    </span>
  ),
  facebook: (
    <span className="flex h-[16px] w-[16px] items-center justify-center">
      <img src={FacebookIcon} alt="" className="h-[16px] w-[16px]" />
    </span>
  ),
  google: (
    <span className="flex h-[16px] w-[16px] items-center justify-center">
      <img src={GoogleIcon} alt="" className="h-[16px] w-[16px]" />
    </span>
  ),
  twitter: null,
  line: (
    <span className="flex h-[16px] w-[16px] items-center justify-center">
      <img src={LineIcon} alt="" className="h-[16px] w-[16px]" />
    </span>
  ),
}

export default SocialLoginButton
